export { DetailsBlock } from "./DetailsBlock";
